import { render, staticRenderFns } from "./CreateFixedLocation.vue?vue&type=template&id=24b034f8&scoped=true&"
import script from "./CreateFixedLocation.vue?vue&type=script&lang=js&"
export * from "./CreateFixedLocation.vue?vue&type=script&lang=js&"
import style0 from "./CreateFixedLocation.vue?vue&type=style&index=0&id=24b034f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b034f8",
  null
  
)

export default component.exports